import { render, staticRenderFns } from "./OrdersSection.vue?vue&type=template&id=f5430eb8&"
import script from "./OrdersSection.vue?vue&type=script&lang=ts&"
export * from "./OrdersSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports